const mergeDeep = (target, source) => {
  if (typeof target !== "object" || typeof source !== "object") {
    return source;
  }

  const result = { ...target };
  for (const key in source) {
    if (Array.isArray(source[key])) {
      result[key] = source[key];
    } else if (typeof source[key] === "object" && source[key] !== null) {
      result[key] = mergeDeep(target[key] || {}, source[key]);
    } else {
      result[key] = source[key];
    }
  }
  return result;
};

const overrideHandlers = {
  smsDisclaimer: (content, value) => {
    content.smsDisclaimer = value;
    if (content.pricingPlanContent) {
      content.pricingPlanContent.smsDisclaimer = value;
    }
  },

  pricingPlan: (content, overridePlan) => {
    if (!overridePlan?.plans || !content.pricingPlan?.plans) return;

    overridePlan.plans.forEach((plan, i) => {
      const targetPlan = content.pricingPlan.plans[i];
      if (targetPlan?.heading === plan.heading) {
        content.pricingPlan.plans[i] = mergeDeep(targetPlan, plan);
      }
    });
  },

  pricingComparison: (content, overrideComparison) => {
    if (!overrideComparison?.overrideFeatures) return;

    overrideComparison.overrideFeatures.forEach((overrideFeature) => {
      content.pricingComparison?.categories?.forEach((category) => {
        category.list?.forEach((list) => {
          const targetFeature = list.features?.find(
            (f) => f.heading === overrideFeature.heading
          );
          if (targetFeature) {
            Object.assign(targetFeature, overrideFeature);
          }
        });
      });
    });
  },
};

export const applyPricingGeoOverrides = (baseContent, country) => {
  if (baseContent.geoExclude?.includes(country)) {
    return baseContent;
  }

  const overrides =
    baseContent.geoOverrides?.[country] || baseContent.geoOverrides?.default;
  if (!overrides) return baseContent;

  const content = { ...baseContent };

  Object.entries(overrides).forEach(([key, value]) => {
    const handler = overrideHandlers[key];
    if (handler) {
      handler(content, value);
    } else {
      content[key] = value;
    }
  });

  return content;
};
